<template>
    <div>
        <facet-list
            v-if="availableFacets.department_id"
            :facets="availableFacets.department_id"
            facet-id="department_id"
            title="Department"
        />
        <facet-list
            v-if="availableFacets.article_type_id"
            :facets="availableFacets.article_type_id"
            facet-id="article_type_id"
            title="Article Type"
        />
        <facet-list
            v-if="availableFacets.resource_type_id"
            :facets="availableFacets.resource_type_id"
            facet-id="resource_type_id"
            title="Resource Type"
        />
        <facet-list
            v-if="availableFacets.resource_category_id"
            :facets="availableFacets.resource_category_id"
            facet-id="resource_category_id"
            title="Resource Category"
        />
        <facet-list
            v-if="availableFacets.audience_id"
            :facets="availableFacets.audience_id"
            facet-id="audience_id"
            title="Audience"
        />
        <facet-list
            v-if="availableFacets.product_id"
            :facets="availableFacets.product_id"
            facet-id="product_id"
            title="Product"
        />
        <facet-list
            v-if="availableFacets.region_id"
            :facets="availableFacets.region_id"
            facet-id="region_id"
            title="Region"
        />
        <facet-list
            v-if="availableFacets.tag_id"
            :facets="availableFacets.tag_id"
            facet-id="tag_id"
            title="Tag"
        />
        <facet-list
            v-if="availableFacets.topic_id"
            :facets="availableFacets.topic_id"
            facet-id="topic_id"
            title="Topic"
        />
    </div>
</template>
<script>
import FacetList from './FacetList.vue';

export default {
    name: 'FacetLists',
    components: { FacetList },
    props: {
        availableFacets: {
            type: Object,
            required: true,
        },
    },
};
</script>
